import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { EvaluationData } from '@core/tellent-assistant-types';
import { AvatarComponent, IconComponent } from '@core/user-interface-legacy';

import { ListCardComponent } from '../../list-card/list-card.component';

@Component({
  selector: 'rt-list-item-evaluation',
  imports: [ListCardComponent, AvatarComponent, IconComponent, TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './list-item-evaluation.component.html',
  styleUrl: './list-item-evaluation.component.less',
})
export class ListItemEvaluationComponent {
  public readonly data = input.required<EvaluationData>();
}
